var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('h1',[_vm._v("访问受限")]),_vm._v(" "),(_vm.reason === 'no_token')?_c('p',[_vm._v("\n    缺少有效访问凭证\n  ")]):(_vm.reason === 'invalid_token')?_c('p',[_vm._v("\n    访问凭证无效\n  ")]):(_vm.reason === 'network_error')?_c('p',[_vm._v("\n    网络错误\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be4bc846","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ErrorPage.vue
// module id = null
// module chunks = 